import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { LabelService } from 'src/app/_services/label.service';

@Component({
  selector: 'app-etiket-duzenle',
  templateUrl: './etiket-duzenle.component.html',
  styleUrls: ['./etiket-duzenle.component.css']
})
export class EtiketDuzenleComponent implements OnInit {


  constructor( 
   private labelService:LabelService,
    private formBuilder:FormBuilder,
    private activeModal:NgbActiveModal,
    private toastr: ToastrService
  ) { }
  submitted=false;
  @Input() label:any;
  definitionForm:FormGroup;
  ngOnInit() {

    this.definitionForm = this.formBuilder.group({
      drugName:[this.label.drugLabelInformation.drugName],
      usagePurpose: [this.label.drugLabelInformation.usagePurpose],
      usageInstructions:[this.label.drugLabelInformation.usageInstructions],
      warnings:this.formBuilder.array([])
    });

    this.label.drugLabelInformation.warnings.forEach(element => {
        this.addWarning(element);
    });
  }
  close(){
    this.activeModal.close();
  }

  save(){

    var model=this.definitionForm.value;
    model.warnings=model.warnings.map(x=>x.property);




     this.labelService.updateLabel(model,this.label.id,false).subscribe(res=>{
        this.toastr.success('','Etiket güncellendi!');
          this.activeModal.close();
     },err=>{
        this.toastr.error('','Etiket güncelleme sırasında hata oluştu!');
      });

  }


 saveall(){
   var model=this.definitionForm.value;
    model.warnings=model.warnings.map(x=>x.property);




     this.labelService.updateLabel(model,this.label.id,true).subscribe(res=>{
        this.toastr.success('','Etiket güncellendi!');
          this.activeModal.close();
     },err=>{
        this.toastr.error('','Etiket güncelleme sırasında hata oluştu!');
      });
  }


   getWarning() {
    return this.definitionForm.get("warnings") as FormArray;
  }

  addWarning(name:any) {
    this.getWarning().push(this.createWarning(name));
  }

  createWarning(name:any): FormGroup {
    return this.formBuilder.group({
      property: [name]
     
    });
  }
  
  removeWarning(i) {
    this.getWarning().removeAt(i);
  }

 
}
